import { render } from "./ui-toggler.vue?vue&type=template&id=66978cc1&scoped=true&ts=true"
import script from "./ui-toggler.vue?vue&type=script&lang=ts"
export * from "./ui-toggler.vue?vue&type=script&lang=ts"

import "./ui-toggler.vue?vue&type=style&index=0&id=66978cc1&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66978cc1"]])

export default __exports__